import types from './mutationTypes';

export default {
  [types.SET_RULES](state, rules) {
    state.rules = rules;
  },
  [types.SET_PAYTABLE](state, paytable) {
    state.paytable = paytable;
  },
  [types.UPDATE_FUTURE](state, future) {
    state.betInputData.future = future;
  },
  [types.SET_SINGLE_BET_INPUT_VALUE](state, { inputId, inputValue }) {
    if (inputValue === '') {
      delete state.betInputData.value[inputId];
    } else {
      state.betInputData.value[inputId] = inputValue;
    }
  },
};
